export default {
    methods: {
        modifyQueryString(action, key, value) {
            if (!('URLSearchParams' in window)) {
                return;
            }

            const searchParams = new URLSearchParams(window.location.search);

            if (action === 'add') {
                searchParams.set(key, value);
            } else if (action === 'clear') {
                searchParams.delete(key);
            }

            return window.location.pathname + '?' + searchParams.toString();
        },
        addToQueryString(key, value) {
            return this.modifyQueryString('add', key, value);
        },
        clearQueryString(key) {
            return this.modifyQueryString('clear', key);
        }
    }
};
